<template>
  <div v-if="label != null" ref="element" class="PageFooterBand">
    <CollectorComponents
      v-for="(child, i) in src._children"
      @resize="label.resize"
      :parentOffset="label.offset"
      :src="child"
      :type="child._tipo"
      :key="i"
    />
  </div>
</template>
<script>
import LabelComponent from "@/classes/LabelComponent.js";

export default {
  name: "PageFooterBand",
  props: {
    src: Object,
    parentOffset: Object,
  },
  data() {
    return {
      label: null,
    };
  },
  components: {
    CollectorComponents: () => import("./CollectorComponents.vue"),
  },
  methods: {},
  mounted() {
    this.label = new LabelComponent(this);
    this.$nextTick(() => {
      const style = {
        width: this.src.Width == null ? "auto" : this.src.Width + "px",
        height: this.src.Height == null ? "auto" : this.src.Height + "px",
        top:
          this.src.Top == null
            ? "0"
            : this.src.Top - this.parentOffset.top + "px",
        left:
          this.src.Left == null
            ? "0"
            : this.src.Left - this.parentOffset.Left + "px",
        position: "absolute",
        border: "1px solid black",
        overflow: "hidden",
        boxSizing: "border-box",
      };
      this.label.getStyle(style);
      this.label.rendered = true;
    });
  },
};
</script>
